module.exports = __webpack_public_path__ + "img/home_banner_web_BG1.e91020e7.png";